export class ValidationSummarizerDemoScreenCodeConstant {

  //#region Properties

  public static readonly withMessageTemplate = 'VALIDATION_SUMMARIZER_DEMO.WITH_MESSAGE_TEMPLATE';

  public static readonly withVisibilityHandler = 'VALIDATION_SUMMARIZER_DEMO.WITH_VISIBILITY_HANDLER';

  public static readonly withTemplateDriven = 'VALIDATION_SUMMARIZER_DEMO.WITH_TEMPLATE_DRIVEN';

  public static readonly withCustomValidator = 'VALIDATION_SUMMARIZER_DEMO.WITH_CUSTOM_VALIDATOR';

  public static readonly withBasicValidator = 'VALIDATION_SUMMARIZER_DEMO.WITH_BASIC_VALIDATOR';

  //#endregion

}
